var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "73110EEB-D9F7-4A72-A6F3-D5EC1F31A73C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client-|-Upload-Chart",
    transform: "translate(-791.000000, -428.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FileUpload",
    transform: "translate(791.000000, 305.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 123.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#EBEBEE",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2853949,27.2590762 C20.9231377,27.6213334 20.7218837,28.104343 20.7218837,28.6276034 C20.7218837,29.1508638 20.9231377,29.6338734 21.2853949,29.9961307 C22.0501602,30.7608959 23.2576842,30.7608959 24.0224494,29.9961307 L32.0321288,21.9864513 C32.796894,21.2216861 33.2396528,20.1751653 33.2396528,19.0883936 C33.2396528,18.001622 32.796894,16.995352 32.0321288,16.190336 C30.4623475,14.6205547 27.8460455,14.6205547 26.2764943,16.190336 L17.7838053,24.7235057 C16.6567829,25.8505282 16.01277,27.3800586 16.01277,28.9498398 C16.01277,30.5196211 16.6567829,32.0491515 17.7838053,33.1761739 C20.1183517,35.5107204 23.901927,35.5107204 26.2364735,33.2164247 L32.4350968,27.098303 C32.8376048,26.695795 33.4816176,26.695795 33.8438748,27.098303 C34.2463828,27.500811 34.2463828,28.1448238 33.8438748,28.507081 L27.6452515,34.7057044 C26.0754703,36.2352348 24.0629302,37 22.0101394,37 C19.9573485,37 17.9045577,36.2352348 16.3345464,34.6654536 C14.805016,33.1359231 14,31.1233831 14,28.9898606 C14,26.8563382 14.8452668,24.8440281 16.3345464,23.3142677 L24.8677162,14.7810979 C27.2425135,12.4063007 31.1063603,12.4063007 33.4813876,14.7810979 C34.6486608,15.9483712 35.2524228,17.4779016 35.2524228,19.0879336 C35.2524228,20.6979657 34.60841,22.2677469 33.4813876,23.3947693 L25.4312274,31.4449295 C23.901697,32.9744599 21.3658966,32.9744599 19.8365961,31.4449295 C19.0718309,30.6801643 18.6693229,29.714145 18.6693229,28.6676242 C18.6693229,27.6211034 19.0718309,26.6148334 19.8365961,25.890319 L27.3632659,18.3636492 C27.7657739,17.9611412 28.4097867,17.9611412 28.7720439,18.3636492 C29.1745519,18.7661572 29.1745519,19.41017 28.7720439,19.7724272 L21.2853949,27.2590762 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.9983d17ca9527b36bdb630512a6ab840.svg";
export { ForwardRef as ReactComponent };